export default {
	darkerGray: '#151516',
	darkGray: '#1A1A1F',
	gray: 'rgb(28, 28, 30)',
	medGray: '#54545A',
	white: '#ffffff',
	purple: '#362A68',
	green: '#019C00',
	paleGreen: '#A6FF79',
	red: '#FF443A',
	textGray: '#878793',
	textLight: '#B2B2BF',
	popoverPackground: '#151516',
	buttonGray: '#1A1A1F',
	nearWhite: '#FCFCFC',
	textBlue: '#0023F5',
	textGreen: '#A2FA4E',
	textYellow: '#FFFC54',
	eggplant: '#522967',
	eggplantLight: '#763A95',
	initialBackgroundColor: '#151515',
	lemon: '#FFF85C',
	hotpink: '#EE79B7', // AH 400 / AH-400 ?
	pinkLemonadePink: '#FF6AE6',
	black: '#000000',
	gray33: '#333333',

	blGrayscale100: '#FFFFFF',
	blGrayscale200: '#E5E4EC',
	blGrayscale300: '#BFBBCF',
	blGrayscale400: '#908CA0',
	blGrayscale500: '#625E70',
	blGrayscale600: '#4F4C57',
	blGrayscale700: '#3C3A42',
	blGrayscale800: '#312F38',
	blGrayscale900: '#26242B',
	blGrayscale1000: '#1A1A1F',
	blGrayscale1100: '#121114',
	blGrayscale1200: '#09090A',

	blSemanticRed100: '##FFD7DF',
	blSemanticRed200: '#FFAFBF',
	blSemanticRed300: '#FF879F',
	blSemanticRed400: 'var(--bl-semantic-red-400)',
	blSemanticRed500: '#FF375F',
	blSemanticRed600: '#CE2E4E',
	blSemanticRed700: '#9D253D',
	blSemanticRed800: '#6B1B2C',
	blSemanticRed900: '#3A121B',

	blPrimaryRed500: '#DE352C',
	blPrimaryRed600: '#B32C25',
};
